import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import VehicleItem from "./components/VehicleItem";
import { VehiclesList, VehiclesListContainer } from "./vehiclesWidgetStyle";
import { GetVehicle } from "@data/repositories/Vehicle/queryVehicle";
import { useMutationVehicle } from "@data/repositories/Vehicle/mutationVehicle";
import { DefaultLoadingOverlay } from "@ui/components/LoadingOverlay/DefualtLoadingOverlay";

export type Props = {
  vehicles: GetVehicle[];
};

export const VehiclesWidget: FC<Props> = ({ vehicles }) => {
  const navigate = useNavigate();
  const { updateVehicleActive } = useMutationVehicle();

  const onSUbmitActive = (vehicle: GetVehicle) => {
    updateVehicleActive.mutate(vehicle, {
      onError: (err: any) => {
        switch(err.response.data.error_code){
          case "E400009":
            alert("車両が存在しません");
            break;
          case "E400018":
            alert("走行環境が無効です");
            break;
          default:
            alert("リクエストに失敗しました");
            break;
        }
      },
    });
  };

  const onClickNavigate = (vehicle: GetVehicle) => {
    navigate(`/vehicles/${vehicle.vehicle_id}`, {
      state: {
        vehicle_id: vehicle.vehicle_id,
        alias_name: vehicle.alias_name,
        is_active: vehicle.is_active,
        ver_no: vehicle.ver_no,
        user_id: vehicle.user_id,
        workspace_cd: vehicle.workspace_cd,
        dash_token: vehicle.dash_token,
        workspace_m: vehicle.workspace_m,
      },
    });
  };

  return (
    <>
      <VehiclesListContainer>
        {vehicles.length > 0 &&
          vehicles.map((vehicle, index) => (
            <VehiclesList key={index}>
              <VehicleItem
                vehicle={vehicle}
                onClickNavigate={onClickNavigate}
                onSUbmitActive={onSUbmitActive}
              />
            </VehiclesList>
          ))}
      </VehiclesListContainer>
      {updateVehicleActive.isLoading && (
        <DefaultLoadingOverlay
          visible={updateVehicleActive.isLoading}
          loaderSize="lg"
        />
      )}
    </>
  );
};

export default VehiclesWidget;
